import { Navigate, useSearchParams } from "react-router-dom"
import { memo, useEffect } from "react"

import { useCheckSessionStatusMutation } from "../../app/stripeApiSlice"
import Spinner from "../../components/Spinner"
import Success from "./Success"
import Failure from "./Failure"
import useAuth from "../../hooks/useAuth"

const StripeReturnPage = memo(() => {
  const searchParams = useSearchParams()
  const sessionId = searchParams[0].get("session_id")
  const { uid } = useAuth()

  const [checkSessionStatus,
    {
      data,
      isSuccess,
      isError,
      error,
      isLoading
    }] = useCheckSessionStatusMutation()

  useEffect(() => {
    if (sessionId) {
      checkSessionStatus({ sessionId, uid })
    }
  }, [sessionId])

  if (!sessionId) {
    return <Navigate to="/error" />
  }

  if (isLoading) return <Spinner />

  if (isError) {
    console.error(error)
    return <Navigate to="/error" />
  }

  if (isSuccess) {
    return data.status === "complete" ? (
      <Success {...data} />
    ) : (
      <Failure />
    )
  }

  return null
})

export default StripeReturnPage